const { default: cookies } = require('./cookies');
import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { dateTimeTolocale } from './converter';

const typeBgColor = {
  green: 'green',
  red: 'red',
  yellow: '#ffb703',
  orange: 'orange',
  purple: 'purple',
  darkred: 'darkred',
};

const getGate = (flight) => {
  const stn = cookies.get('station_code');
  return flight?.org === stn ? flight?.dept_gate : flight?.arr_gate;
};


const getHistory = async (data) => {
  let dataClone = cloneDeep(data.data);
  dataClone.map((row) => {
    let operation_desc = '';
    let bgColor = '';
    switch (row.type) {
      case 'Statistics':
        bgColor = typeBgColor.green;
        break;
      case 'Report':
        if (row.new_details.status === 'Finalized') {
          bgColor = typeBgColor.yellow;
        } else if (row.new_details.status === 'Approved') {
          bgColor = typeBgColor.green;
        } else if (row.new_details.status === 'Rejected') {
          bgColor = typeBgColor.red;
        } else {
          bgColor = typeBgColor.yellow;
        }
        break;
      case 'Attachment':
        bgColor = typeBgColor.orange;
        break;
      case 'Checklist':
        bgColor = typeBgColor.purple;
        break;
      case 'Discrepancy':
        bgColor = typeBgColor.darkred;
        break;
      case 'No OP':
        bgColor = typeBgColor.purple;
        break;
      default:
        bgColor = typeBgColor.yellow;
        break;
    }
    if (row.type == 'Attachment') {
      if (row.operation == 'ADD') {
        operation_desc = 'Added ' + row.new_details?.name + ' Attachment';
      } else if (row.operation == 'DELETE') {
        operation_desc = 'Deleted ' + row.prev_details?.name + ' Attachment';
      }
    } else if (row.type == 'Checklist') {
      if (typeof row.new_details?.check == 'boolean') {
        operation_desc = row.operation + ' -> ' + (row.new_details?.check ? 'Checked' : 'Unchecked');
      } else {
        operation_desc = row.operation + ' -> remark -> ' + row.new_details?.remark;
      }
    } else if (row.type == 'Statistics') {
      if (row.new_details.length > 0) {
        let updates = [];
        row.new_details.forEach((newItem) => {
          let prev_details = [...Object.values(row.prev_details || {})];
          let prevItem = prev_details.find(item => item.contractrowId === newItem.contractrowId);
          if (prevItem) {
            if (prevItem.quantity != newItem.quantity) {
              updates.push(`${newItem.name}: ${prevItem.quantity || 'N/A'} -> ${newItem.quantity || 'N/A'}`);
            }
          } else {
            if (newItem.quantity !== null && newItem.quantity !== undefined)
              updates.push(`${newItem.name}: N/A -> ${newItem.quantity || 'N/A'}`);
          }
        });
        operation_desc = row.operation + (updates.length > 0 ? ' -> ' + updates.join(', ') : '');

      } else {
        operation_desc = row.operation;
      }
    } else if (row.type == 'Report') {
      operation_desc = row.new_details?.type + ' -> ' + row.operation + (row.new_details?.remark && ' -> ' + row.new_details?.remark);
    } else if (row.type == 'Discrepancy') {
      let operation = '';
      switch (row.operation?.toLowerCase()) {
        case 'add discrepancy':
          operation = 'Discrepancy Added';
          break;
        case 'delete discrepancy':
          operation = 'Discrepancy Deleted';
          break;
        case 'update discrepancy':
          operation = 'Discrepancy Updated';
          break;
        default:
          operation = row.operation;
          break;
      }
      operation_desc = operation + ' -> ' + row.new_details?.awb_no;
    } else if (row.type == 'No OP') {
      operation_desc = 'No OP' + (row.new_details?.noOp && ' -> ' + row.new_details?.noOp) + ' | ' + 'Reason' + (row.new_details?.reason && ' -> ' + row.new_details?.reason);
    } else if (row.type == 'Flight' && row.operation?.toLowerCase() == 'flight details updated') {
      const prev_details = row.prev_details || {};
      const new_details = row.new_details || {};
      let changes = [];
      let fName = {
        'platform': 'Platform',
        'reg_no': 'Reg No',
        'ac_type': 'AC Type',
        'flight_no': 'Flight No',
        'flight_date': 'Flight Date',
        'in_nil_ffm': 'Nil FFM',
        'out_nil_ffm': 'Nil FFM',
        'no_op': 'No OP',
        'nil': 'Nil',
        'is_notified': 'Is Notified',
        'status': 'Status',
        'org': 'Origin',
        'dest': 'Destination',
        'dept_gate': 'Departure Gate',
        'arr_gate': 'Arrival Gate',
        'schdl_dept': 'Sch. Departure',
        'schdl_arr': 'Sch. Arrival',
        'est_dept': 'Est. Departure',
        'est_arr': 'Est. Arrival',
        'act_dept': 'Act. Departure',
        'act_arr': 'Act. Arrival',
      };
      for (const key in new_details) {
        if (Object.prototype.hasOwnProperty.call(new_details, key) && !['in_ffm', 'out_ffm'].includes(key)) {
          if (prev_details[key] !== new_details[key]) {
            let prevValue = prev_details[key] !== undefined && prev_details[key] !== null ? prev_details[key] : 'N/A';
            let newValue = new_details[key] !== undefined && new_details[key] !== null ? new_details[key] : 'N/A';
            if (moment(prevValue, moment.ISO_8601, true).isValid()) {
              // prevValue = moment(prevValue).format('DD MMM YYYY HH:mm');
              prevValue = dateTimeTolocale(prevValue, 'DD MMM YYYY HH:mm');
            }
            if (moment(newValue, moment.ISO_8601, true).isValid()) {
              newValue = dateTimeTolocale(newValue, 'DD MMM YYYY HH:mm');
            }

            changes.push(`${fName[key]}: ${prevValue} -> ${newValue}`);
          }
        }
      }
      operation_desc = row.operation + (changes.length > 0 ? ' -> ' + changes.join(', ') : '');
    } else if (row.type == 'Flight ULD') {
      if (row.operation == 'Add') {
        operation_desc = 'Added ' + row.new_details?.uld_no;
      } else if (row.operation == 'Delete') {
        operation_desc = 'Deleted ' + row.prev_details?.uld_no;
      } else {
        operation_desc = 'Updated ULD ' + (row.new_details?.uld_no || row.prev_details?.uld_no);
        console.log(row);
        let prev_details = row.prev_details || {};
        let new_details = row.new_details || {};
        let changes = [];
        let uName = {
          'uld_no': 'ULD No',
          'is_bulk': 'Is Bulk',
          'org': 'Origin',
          'dest': 'Destination',
          'type': 'Type',
          'uld_type': 'ULD Type',
          'segment': 'Segment',
          'remark': 'Remark',
        };
        for (const key in new_details) {
          if (Object.prototype.hasOwnProperty.call(new_details, key)) {
            if (prev_details[key] !== new_details[key]) {
              console.log(key, prev_details[key], new_details[key]);
              let prevValue = prev_details[key] !== undefined && prev_details[key] !== null ? prev_details[key] : 'N/A';
              let newValue = new_details[key] !== undefined && new_details[key] !== null ? new_details[key] : 'N/A';
              changes.push(`${uName[key]}: ${prevValue} -> ${newValue}`);
            }
          }
        }
        operation_desc += (changes.length > 0 ? ' -> ' + changes.join(', ') : '');

      }
    } else if (row.type == 'Flight AWB') {
      if (row.operation == 'Add') {
        operation_desc = 'Added ' + row.new_details?.awb_no;
      } else if (row.operation == 'Delete') {
        operation_desc = 'Deleted ' + row.prev_details?.awb_no;
      } else {
        operation_desc = 'Updated AWB ' + (row.new_details?.awb_no || row.prev_details?.awb_no);
        let prev_details = row.prev_details || {};
        let new_details = row.new_details || {};
        let changes = [];
        let aName = {
          'awb_no': 'AWB No',
          'org': 'Origin',
          'dest': 'Destination',
          'pcs': 'Pieces',// integer
          'wgt': 'Weight',// float
          'remark': 'Remark',
          'spl_code': 'Special Code',
          'products': 'Products'
        };
        for (const key in new_details) {
          if (Object.prototype.hasOwnProperty.call(new_details, key)) {
            if (key === 'pcs' || key === 'wgt') {
              prev_details[key] = parseFloat(prev_details[key]) || 0;
              new_details[key] = parseFloat(new_details[key]) || 0;
            }
            if (prev_details[key] !== new_details[key]) {
              let prevValue = prev_details[key] !== undefined && prev_details[key] !== null ? prev_details[key] : 'N/A';
              let newValue = new_details[key] !== undefined && new_details[key] !== null ? new_details[key] : 'N/A';
              changes.push(`${aName[key]}: ${prevValue} -> ${newValue}`);
            }
          }
        }
        operation_desc += (changes.length > 0 ? ' -> ' + changes.join(', ') : '');
      }
    }
    else {
      operation_desc = row.operation;
    }
    row.operation_desc = operation_desc;
    row.bgColor = bgColor;
    return operation_desc;
  });

  let newData = dataClone.filter((item) => { return item.operation_desc !== ''; });
  return newData;

};

const ffmSummery = (product, ffm) => {
  let manifestData = [...(ffm?.flight_uld || [])];
  let loose = {
    awbs: 0,
    pcs: 0,
    wgt: 0,
  };
  let intact = {
    awbs: 0,
    pcs: 0,
    wgt: 0,
  };
  let total = {
    awbs: 0,
    pcs: 0,
    wgt: 0,
  };
  let looseulds = {
    LD3: 0,
    LD7: 0,
    MD: 0,
  };
  let intactulds = {
    LD3: 0,
    LD7: 0,
    MD: 0,
  };
  let totalulds = {
    LD3: 0,
    LD7: 0,
    MD: 0,
  };
  let totalAwbLoose = [];
  let totalAwbIntact = [];
  let totalAwbNo = [];
  manifestData?.map((item) => {
    let searchString = ['LD3', 'LD7', 'MD'];
    let uldtype = searchString.find(val => item.uld_type?.includes(val));
    let inc = 1;
    if (item.uld_type?.includes('2X')) {
      inc = 2;
    }
    if (item.type === 'Loose') {
      looseulds[uldtype] += inc;
    }
    if (item.type === 'Intact') {
      intactulds[uldtype] += inc;
    }
    totalulds[uldtype] += inc;
    item?.flight_awbs?.map((awb) => {
      let products = awb?.products?.map(product => product.name) || [];
      if (product == 'ALL' || products.includes(product)) {
        if (item.type === 'Loose') {
          if (totalAwbLoose && !totalAwbLoose.includes(awb.awb_no)) {
            totalAwbLoose.push(awb.awb_no);
          }
          loose.awbs = totalAwbLoose.length;
          loose.pcs += parseInt(awb.pcs || 0);
          loose.wgt += parseFloat(awb.wgt || 0);
        }
        if (item.type === 'Intact') {
          if (totalAwbIntact && !totalAwbIntact.includes(awb.awb_no)) {
            totalAwbIntact.push(awb.awb_no);
          }
          intact.awbs = totalAwbIntact.length;
          intact.pcs += parseInt(awb.pcs || 0);
          intact.wgt += parseFloat(awb.wgt || 0);
        }
        if (totalAwbNo && !totalAwbNo.includes(awb.awb_no)) {
          totalAwbNo.push(awb.awb_no);
        }
        total.awbs = totalAwbNo.length;
        total.pcs += parseInt(awb.pcs || 0);
        total.wgt += parseFloat(awb.wgt || 0);
      }
    });
  });
  return {
    loose,
    intact,
    total,
    looseulds,
    intactulds,
    totalulds
  };
};

const discrepancySummary = (product, discrepancyList) => {
  let manifestData = discrepancyList || [];
  let loose = {
    awbs: 0,
    pcs: 0,
    wgt: 0,
  };
  let intact = {
    awbs: 0,
    pcs: 0,
    wgt: 0,
  };
  let total = {
    awbs: 0,
    pcs: 0,
    wgt: 0,
  };
  let looseulds = {
    LD3: 0,
    LD7: 0,
    MD: 0,
  };
  let intactulds = {
    LD3: 0,
    LD7: 0,
    MD: 0,
  };
  let totalulds = {
    LD3: 0,
    LD7: 0,
    MD: 0,
  };
  let totalAwbLoose = [];
  let totalAwbIntact = [];
  let totalAwbNo = [];
  manifestData?.forEach((item) => {
    // Only process if type is one of the allowed types
    let isAdd = item.type === 'Found Cargo' || item.type === 'Over Carried';
    let isSubtract = item.type === 'Missing Cargo' || item.type === 'Short Shipped';
    if (!isAdd && !isSubtract) return;

    let searchString = ['LD3', 'LD7', 'MD'];
    let uldtype = searchString.find(val => item.uld_type?.includes(val));
    let inc = 1;
    if (item.uld_type?.includes('2X')) {
      inc = 2;
    }
    // ULD counts
    if (item.handled_as === 'Loose') {
      looseulds[uldtype] += isAdd ? inc : -inc;
    }
    if (item.handled_as === 'Intact') {
      intactulds[uldtype] += isAdd ? inc : -inc;
    }
    totalulds[uldtype] += isAdd ? inc : -inc;

    // Airwaybill section
    if (product == 'ALL' || item.prod_code == product) {
      let pcs = parseInt(item.d_pcs || 0);
      let wgt = parseFloat(item.d_wgt || 0);

      if (item.handled_as === 'Loose') {
        if (totalAwbLoose && !totalAwbLoose.includes(item.awb_no)) {
          totalAwbLoose.push(item.awb_no);
          loose.awbs += isAdd ? 1 : -1;
        }
        // loose.awbs = totalAwbLoose.length;
        loose.pcs += isAdd ? pcs : -pcs;
        loose.wgt += isAdd ? wgt : -wgt;
      }
      if (item.handled_as === 'Intact') {
        if (totalAwbIntact && !totalAwbIntact.includes(item.awb_no)) {
          totalAwbIntact.push(item.awb_no);
          intact.awbs += isAdd ? 1 : -1;
        }
        // intact.awbs = totalAwbIntact.length;
        intact.pcs += isAdd ? pcs : -pcs;
        intact.wgt += isAdd ? wgt : -wgt;
      }
      if (totalAwbNo && !totalAwbNo.includes(item.awb_no)) {
        totalAwbNo.push(item.awb_no);
        total.awbs += isAdd ? 1 : -1;
      }
      // total.awbs = totalAwbNo.length;
      total.pcs += isAdd ? pcs : -pcs;
      total.wgt += isAdd ? wgt : -wgt;
    }
  });
  return {
    loose,
    intact,
    total,
    looseulds,
    intactulds,
    totalulds
  };
};
export { getGate, getHistory, ffmSummery, discrepancySummary };